module.exports = __webpack_public_path__ + "img/sory17-2.jpeg";